/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureResource } from '../models/FeatureResource';
import type { ToggleFeatureRequest } from '../models/ToggleFeatureRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FeaturesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Return a list of available features and their status.
     * @returns any OK
     * @throws ApiError
     */
    public getFeatures(): CancelablePromise<{
        data: Array<FeatureResource>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/features',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Return a single feature
     * @returns any OK
     * @throws ApiError
     */
    public getFeature({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<{
        data: FeatureResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/features/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Toggle a feature on or off.
     * @returns any Created
     * @throws ApiError
     */
    public toggleFeature({
        id,
        requestBody,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
        requestBody?: ToggleFeatureRequest,
    }): CancelablePromise<{
        data: FeatureResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/features/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

}
